import styled from "styled-components";
import { Container } from "@material-ui/core";
import MUIDataTable from "mui-datatables";

export const DataTableContainer = styled(Container)`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  
`

export const StyledContainer = styled(Container)`
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${props => props.theme === 'dark' ? '#303030' : '#FFF'};
`

export const StyledTable = styled(MUIDataTable)`
  @media (max-width: 959.95px) {
      .MUIDataTableBodyCell-stackedCommon-261 {
      border: none;
      font-size: inherit;
      white-space: normal;
      height: auto;
      overflow: auto;
    };
    .MUIDataTableBodyCell-cellStackedSmall-263 {
        width: 50%;
        border: none;
        padding: 3px;
    }
  }
`